module.exports = __webpack_public_path__ + "media/3.f0a541f6.wav";